import { addDoc, collection, deleteDoc, doc, getDocs, orderBy, query, Timestamp, updateDoc } from "firebase/firestore";
import { db } from "./firebase";


export const addPublication = async ({...data}) => {
    const docRef = await addDoc(collection(db, "publications"), {
        ...data,
        timestamp: Timestamp.now(),
    });
    console.log("Publication document created:", docRef.id);
    return docRef.id;
}

export const fetchPublications = async (setData) => {
    const q = query(collection(db, "publications"), orderBy("index", 'asc'));
    const querySnapshot = await getDocs(q);
    const dataArr = [];
    querySnapshot.forEach((docSnap) => {
        const data = docSnap.data();
        const id = docSnap.id;
        dataArr.push({ id, ...data });
    });
    setData(dataArr);
}

export const editPublication = async ({ ...data }) => {
    const { id, txt, index, fields, journal, url  } = data
    try {
        const updateData = {
            txt, index, fields, journal, url,
            timestamp: Timestamp.now()
        };

        const docRef = doc(db, "publications", id);
        await updateDoc(docRef, updateData);

        console.log(`Publication document with ID ${id} updated successfully.`);
    } catch (error) {
        console.error("Error updating publication document:", error);
        throw error;
    }
};

export const deletePublication = async (id) => {
    await deleteDoc(doc(db, "publications", id));
    console.log(`Document with id ${id} deleted successfully`);
}